import { render, staticRenderFns } from "./StepsContainer.vue?vue&type=template&id=77b80095&scoped=true&"
var script = {}
import style0 from "./StepsContainer.vue?vue&type=style&index=0&id=77b80095&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b80095",
  null
  
)

export default component.exports